import { css } from '@/styled-system/css';
import FullscreenOverlay from '../../../ui/FullscreenOverlay';
import { ModuleTrigger } from '../../../ui/ModuleTrigger';
import { SpokeFooterCTAs } from '../SpokeFooterCTAs';
import { ListingHeaderActions } from '../ListingHeaderActions';
import { HaloSpokeHeader } from '../HaloSpokeHeader';
import { useDetailPanel } from '../../../ui/DetailPanel';
import { CostAndFeesSpokeContent } from './CostAndFeesSpokeContent';

const footerContainer = css({});

const headerRight = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
});

const footerButtonGroup = css({
  display: 'flex',
  gap: '1x',
  flexWrap: 'wrap',
  width: '100%',
  maxWidth: '400px',
  '& > *': {
    flex: 1,
  },
});

const spokeContainer = css({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
});

const CostAndFeesSpoke = () => {
  return (
    <div className={spokeContainer} data-testid="cost-and-fees-spoke" role="dialog" aria-label="Costs and fees details">
      <HaloSpokeHeader
        title="Costs & fees"
        actions={
          <div className={headerRight}>
            <ListingHeaderActions />
          </div>
        }
      />

      <FullscreenOverlay.Body padding="standard">
        <CostAndFeesSpokeContent />
      </FullscreenOverlay.Body>

      <FullscreenOverlay.Footer>
        <div className={footerButtonGroup} data-testid="cost-and-fees-spoke-footer">
          <SpokeFooterCTAs />
        </div>
      </FullscreenOverlay.Footer>
    </div>
  );
};

export const CostAndFeesFooter = () => {
  const { openPanel, isMobile } = useDetailPanel();

  if (!isMobile) {
    return (
      <div className={footerContainer}>
        <ModuleTrigger
          aria-label="View costs and fees breakdown"
          onClick={() => openPanel('cost-and-fees', CostAndFeesSpokeContent)}
        >
          Costs & fees breakdown
        </ModuleTrigger>
      </div>
    );
  }

  return (
    <div className={footerContainer}>
      <FullscreenOverlay.Root defaultOpen={false}>
        <FullscreenOverlay.Trigger asChild>
          <ModuleTrigger aria-label="View costs and fees breakdown">Costs & fees breakdown</ModuleTrigger>
        </FullscreenOverlay.Trigger>

        <FullscreenOverlay.Portal>
          <FullscreenOverlay.Backdrop>
            <FullscreenOverlay.Content>
              <CostAndFeesSpoke />
            </FullscreenOverlay.Content>
          </FullscreenOverlay.Backdrop>
        </FullscreenOverlay.Portal>
      </FullscreenOverlay.Root>
    </div>
  );
};
